import React from "react";
import 'styles/MainPageLoader.css';

const MainPageLoader = () => {
  return <div className="spinner" />;
};

export default MainPageLoader;
